export const colors = {
  whiteColour: "#ffffff",
  offWhiteColour: "#f6f7f9",
  darkOffWhiteColour: "#d8d8d8",
  orangeColour: "#ed5434",
  lightOrangeColour: "#ff6f51",
  slateColour: "#2a2730",
  lightSlateColour: "#3e3f48",
  darkGreyColour: "#50575f",
  lightGreyColour: "#9aa2ab",
  vLightGreyColour: "#cdcdd1",
  errorColour: "#d80033",
  greenBackgroundColour: "#daebea",
  goldBackgroundColour: "#f8f6f1",
};

export const fonts = {
  tiempos: '"Tiempos-Text", "Times", serif',
  akkurat: '"Akkurat", "Arial", sans-serif',
};

export const typography = {
  constants: {
    baseLineHeight: 24,
    smallVerticalSpacing: 12,
    smallHorizontalSpacing: 19.4,
    baseTypeUnit: 8,
  },
  h1: {
    fontFamily: fonts.tiempos,
    fontSize: 37,
    lineHeight: (42 / 37),
  },
  h2: {
    fontFamily: fonts.tiempos,
    fontSize: 26,
    lineHeight: (34 / 26),
  },
  h3: {
    fontFamily: fonts.tiempos,
    fontSize: 20,
    lineHeight: (27 / 20),
  },
  h4: {
    fontFamily: fonts.tiempos,
    fontSize: 17,
    lineHeight: (22 / 17),
  },
  h5: {
    fontFamily: fonts.akkurat,
    fontSize: 14,
    fontWieght: 'bold',
  },
  body: {
    fontFamily: fonts.akkurat,
    fontSize: 14,
    lineHeight: (21 / 14),
  },
  small: {
    fontFamily: fonts.akkurat,
    fontSize: 14,
    lineHeight: (21 / 14),
  },
  prompt: {
    fontFamily: fonts.akkurat,
    fontSize: 13,
    lineHeight: (18 / 13),
  },

  xSmall: {
    fontFamily: fonts.akkurat,
    fontSize: 12,
    lineHeight: (16 / 12),
  }
};

export const magicNumbers = {
  constants: {
    phi: 1.61803398874989
  },
  homeListings: {
    gutterWidth: 48,
    columnWidth: 38,
  },
};

export const layout = {
  constants: {
    baseLineHeight: 24,
    smallVerticalSpacing: 12,
  },
  homeListings: {
    content: {
      marginRight: 'calc((100% / 3) + (100% * 0.025))',
    },
  },
};



/** WEBPACK FOOTER **
 ** ./static/js/onefinestay/apps/homes/detail/views/styles.js
 **/